import { componentName, HcaptchaClass } from './HcaptchaClass';

customElements.define(componentName, HcaptchaClass);

export { HcaptchaClass, componentName };
